import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { I18nModule, provideConfig } from '@spartacus/core';
import { LaunchDialogModalLayoutConfig } from 'src/app/dialog/custom-launch-dialog-config';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReorderComponent } from './reorder.component';

@NgModule({
  declarations: [ReorderComponent],
  exports: [ReorderComponent],
  imports: [CommonModule, MatIconModule, I18nModule, MatBadgeModule, MatTooltipModule, SharedModule],
  providers: [
    provideConfig({
      ...LaunchDialogModalLayoutConfig.SavedCarts,
    }),
  ],
})
export class ReorderModule {}
